var $ = require('jquery'); // 30kb
var angular = require('angular'); // 52kb
require('./components/lib/catalogue.js');
require('../../../node_modules/angular-material'); // 70kb
require('angular-route'); //2.4
require('bootstrap-sass');// TODO used?
require('./components/lib/behaviors.js');
require('./components/lib/utils.js');
require('./components/lib/animations.js');
require('./components/lib/filters.js');
require('./components/lib/colors.js');
require('./components/lib/EditingModule.js'); // 6kb
require('./components/lib/overlay.js');
require('./components/lib/messages.js');
require('./components/lib/msResponsiveUi.js');
require('./components/groups/render/renderGroups-directive.js');
require('./components/slots/slots.js'); // 1.5kb
require('./components/lib/msExt.js'); // 2.5kb
require('./components/lib/msAuth.js');
require('./components/lib/SidebarStuff.js');
require('./script.js');
require('./templates.js'); // 15kb
global.rangy = require('../../../node_modules/textangular/dist/textAngular-rangy.min.js'); // 16kb
require('../../../node_modules/textangular/dist/textAngular-sanitize.min.js'); // 4kb
require('textangular'); // 20kb
require('angulartics');
require('angulartics-google-analytics');
// angular animate 9kb
// app.js (this) 8kb
var html2canvas = require('../../../node_modules/html2canvas/dist/html2canvas.min.js');
window.html2canvas = html2canvas;// html2canvas 20kb

var app = angular.module('myApp', [
    'behaviors',
    'filters',
    'ngSanitize',
    require('angular-messages'),
    'colors',
    'renderGroups',
    'slots',
    'msUtils',
    'msExt',
    'msAuth',
    'animations',
    'EditingModule',
    'angulartics',
    'angulartics.google.analytics',
    'templates',
    'SidebarStuff',
    'textAngular',
    'ngRoute',
    'ngMaterial',
    'overlay',
    'messages',
    'responsiveUi'
]);

app.config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

// configure our routes
app.config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
    $routeProvider
        .when('/dashboard/', {
            templateUrl: 'dashboard/dashboard.html',
            controller: 'dashboardCtrl',
            auth: {scopes: ['user']}
        })
        .when('/site/:domain*', {
            templateUrl: 'view.html',
            controller: 'myCtrl',
            auth: {scopes: ['user'], redirect: '/dashboard/'}
        })
        .when('/dashboard/admin/:resource?/:id?', {
            templateUrl: 'dashboard/msAdmin.html',
            controller: 'msAdminCtrl',
            auth: {scopes: ['admin'], redirect: '/dashboard/'}
        })
        .otherwise({
            redirectTo: '/dashboard/'
        });
    $locationProvider.html5Mode(true);
}]);


app.controller('MenuCtrl', ['$scope', '$timeout', function ($scope, $timeout) {
    $scope.device = document.documentElement.classList.contains('desktop') ? 'desktop' : 'mobile';
    var self = this;
    self.hidden = false;
    self.isOpen = false;
    self.isForceOpen = false;
    self.disableToolTips = false;
    self.autohide = false;
    self.tooltipVisible = false;
    self.disableToolTipsF = function () {
        self.disableToolTips = true;
        self.tooltipVisible = false;
        self.autohide = true;
    };

    self.toggleForceOpen = function () {
        if ($scope.device != 'mobile') {
            self.isForceOpen = !self.isForceOpen;
            $scope.$root.user_settings.fabButtonForceOpen = self.isForceOpen;
        }
    };

    $scope.$on('msAuthenticated', function () {
        if ($scope.$root.user_settings.fabButtonForceOpen && $scope.device != 'mobile') {
            setTimeout(function () {
                self.isForceOpen = true;
                $scope.$apply();
            }, 2500);
        }
    });

    $scope.$root.menuController = self;

    // On opening, add a delayed property which shows tooltips after the speed dial has opened
    // so that they have the proper position; if closing, immediately hide the tooltips
    $scope.$watch('m.isForceOpen', function (isForceOpen) {
        if (self.isForceOpen || isForceOpen) {
            self.isOpen = true;
        }
    });
    $scope.$watch('m.isOpen', function (isOpen) {
        if (self.isForceOpen) {
            self.isOpen = true;
        }
        if (isOpen || self.isForceOpen) {
            $scope.$root.$broadcast('speed-dial-opened');
            $timeout(function () {
                $scope.tooltipVisible = self.disableToolTips ? false : self.isOpen;
            }, 700);
        } else {
            if (!self.isForceOpen) {
                $scope.$root.$broadcast('speed-dial-closed');
                $scope.tooltipVisible = self.disableToolTips ? false : self.isOpen;
            }
        }
    });

    $scope.showGridBottomSheetWrap = function ($event, param, on_add) {
        self.hidden = true;
        $scope.showGridBottomSheet($event, param, on_add).then(function () {
            self.hidden = false;
        }).catch(function () {
            self.hidden = false;
        });
    };

    self.items = [
        {name: "Add", icon: "add", tooltip: "Element hinzufügen", callback: $scope.showGridBottomSheetWrap},
        //{name: "Save", icon: "save", tooltip: "Speichern", callback: $scope.save, disabled: function () { return $scope.inSaveAction; }},
        {name: "Preview", icon: "pageview", tooltip: "Publizieren", callback: $scope.preview},
        {name: "Publish", icon: "public", tooltip: "Publizieren", callback: $scope.publish},
        {name: "Account", icon: "account_circle", tooltip: "Mein Konto", callback: $scope.account},
        {name: "Settings", icon: "settings", tooltip: "Einstellungen", callback: $scope.toggleLeft}
    ];


    for (var i = 0; i < self.items.length; i++) {
        var conditionRemovePreviewOnMobile = self.items[i].name === 'Preview' && $scope.device === 'mobile';
        var conditionRemovePublishOnNonMobile = self.items[i].name === 'Publish' && $scope.device !== 'mobile';

        if (conditionRemovePreviewOnMobile || conditionRemovePublishOnNonMobile) {
            self.items.splice(i, 1);
        }
    }
}]);

app.service('api', ['$http', 'msAuth', function ($http, msAuth) {
    var msApiService;
    msApiService = {};

    msApiService.raw = function (uri) {
        return $http.get('/api/' + uri, msAuth.request_auth_headers());
    };

    msApiService.getAll = function (name) {
        return $http.get('/api/v2/' + name + 's', msAuth.request_auth_headers());
    };

    msApiService.get = function (name, id) {
        return $http.get('/api/v2/' + name + '/' + id, msAuth.request_auth_headers());
    };

    msApiService.update = function (name, id, data) {
        return $http.put('/api/v2/' + name + '/' + id, data, msAuth.request_auth_headers());
    };

    msApiService.delete = function (name, id) {
        return $http.delete('/api/v2/' + name + '/' + id, msAuth.request_auth_headers());
    };

    msApiService.create = function (name, data) {
        return $http.post('/api/v2/' + name, data, msAuth.request_auth_headers());
    };

    return msApiService;
}]);

app.service('msAdminConfig', [function () {
    var msAdminConfig;
    msAdminConfig = {};
    msAdminConfig.admins = [
        {
            name: 'user',
            icon: 'people_outline',
            list: [
                {field: 'id', type: 'link'},
                {flex: 5, field: 'active', type: 'bool'},
                {flex: 5, field: 'admin', type: 'bool'},
                {field: 'email', type: 'email'},
                {flex: 5, field: 'login_count', type: 'numb'},
                {field: 'last_login_at', type: 'text'},
                {field: 'confirmed_at', type: 'text'}
            ],
            detail: [
                {field: 'id', type: 'link'},
                {field: 'active', type: 'bool'},
                {field: 'admin', type: 'bool'},
                {field: 'email', type: 'email'},
                {field: 'login_count', type: 'numb'},
                {field: 'last_login_at', type: 'text'},
                {field: 'confirmed_at', type: 'text'}
            ]
        },
        {
            name: 'page',
            icon: 'web',
            list: [
                {field: 'id', type: 'link'},
                {field: 'domain', type: 'text'},
                {field: 'updated_at', type: 'text'},
                {field: 'created_at', type: 'text'}
            ]
        }
    ];
    msAdminConfig.getDef = function (type, name) {
        var admin = msAdminConfig.isAdmin(name);
        if (!admin || !admin[type]) return [];
        return admin[type];
    };
    msAdminConfig.isAdmin = function (admin) {
        for (var i = 0; i < msAdminConfig.admins.length; i++) {
            if (msAdminConfig.admins[i].name === admin) return msAdminConfig.admins[i];
        }
        return null;
    };

    return msAdminConfig;
}]);

app.controller('msAdminCtrl', ['$scope', 'api', '$routeParams', '$location', 'msAdminConfig',
    function ($scope, api, $routeParams, $location, msAdminConfig) {
        $scope.resource = $routeParams['resource'];
        $scope.id = $routeParams['id'];
        $scope.config = msAdminConfig;

        console.log($scope.resource, $scope.id);
        if ($scope.resource && !msAdminConfig.isAdmin($scope.resource)) $location.path('/dashboard/admin');
        $scope.obj = {};
        $scope.mod = {};
        $scope.objects = [];
        $scope.show = '';
        $scope.def = [];

        $scope.go = function (path) {
            $location.path('/dashboard/admin/' + path);
        };

        $scope.state = '';
        $scope.save = function () {
            $scope.state = '';
            try {
                api.update($scope.resource, $scope.mod.id, angular.fromJson(angular.toJson($scope.mod))).then(function () {
                    $scope.state = 'saved';
                    $scope.invalid = {};
                    $scope.changed = {};
                    $scope.obj = angular.copy($scope.mod);
                }, function () {
                    $scope.state = 'server error';
                });
            } catch (e) {
                $scope.state = 'error ' + e;
            }
        };

        $scope.$on('msAuthenticated', function () {
            if ($scope.resource && $scope.id) {
                $scope.show = 'detail';
                $scope.def = [];
                var def = msAdminConfig.getDef($scope.show, $scope.resource);

                function isField(field) {
                    for (var i = 0; i < def.length; i++) {
                        if (def[i].field === field) return def[i];
                    }
                    return null;
                }

                api.get($scope.resource, $scope.id).then(function (response) {
                    $scope.obj = response.data.result;
                    $scope.mod = angular.copy($scope.obj);
                    $scope.invalid = {};
                    $scope.changed = {};

                    $scope.update = function (field, value) {
                        try {
                            $scope.mod[field] = angular.fromJson(value);
                            $scope.invalid[field] = false;
                        } catch (e) {
                            $scope.invalid[field] = true;
                        }
                        $scope.changed[field] = angular.toJson($scope.obj[field]) !== angular.toJson($scope.mod[field]);
                    };

                    Object.keys($scope.obj).forEach(function (key) {
                        if (isField(key)) {
                            $scope.def.push(isField(key));
                        } else {
                            $scope.def.push({field: key, type: 'text'});
                        }
                    });
                })
            } else if ($scope.resource) {
                $scope.show = 'list';
                $scope.def = msAdminConfig.getDef($scope.show, $scope.resource);
                api.getAll($scope.resource).then(function (response) {
                    response.data.result.forEach(function (user) {
                        $scope.objects.push(user);
                    });
                    console.log($scope.objects)
                })
            } else {
                $scope.show = 'index';
            }
        });
    }]);

app.controller('dashboardCtrl', ['$scope', 'msAuth', 'site', '$location', 'messages', '$timeout', '$mdDialog', '$mdMedia',
    function ($scope, msAuth, site, $location, messages, $timeout, $mdDialog, $mdMedia) {
        window.scope = $scope;
        $scope.msSite = site;
        $scope.pages = [];

        messages.hide();

        $scope.go = function (path) {
            $location.path(path);
        };

        $scope.host = $location.host();
        $scope.protocol = $location.protocol();
        if ($location.port() != 80 && $location.port() != 443) {
            $scope.host += ':' + $location.port();
        }
        if ($scope.host.substr(0, 4) == 'www.') {
            $scope.host = $scope.host.substr(4);
        }

        $scope.delete_site = function (domain, event) {
            var element = event.toElement ? event.toElement : event.target;
            if (element.tagName != 'BUTTON' && element.parentElement) element = element.parentElement;
            element.disabled = 'disabled';

            var confirm = $mdDialog.confirm()
                .title('Seite "' + domain + '" löschen?')
                .content('Diese Aktion kann nicht rückgängig gemacht werden.')
                .targetEvent(event)
                .cancel('Abbrechen').ok('Löschen');

            $mdDialog.show(confirm).then(function () {
                site.delete_page(domain, function () {
                    $timeout(function () {
                        element.disabled = null;
                        var index = 0;
                        angular.forEach($scope.pages, function (page, i) {
                            if (page.domain === domain) index = i;
                        });
                        $scope.pages.splice(index, 1);
                    }, 500);
                    messages.notify('delete-page-success', {'domain': domain});
                }, function () {
                    $timeout(function () {
                        element.disabled = null;
                    }, 500);
                    messages.notify('delete-page-failed', {'domain': domain});
                });
            }, function () {
                element.disabled = null;
            });
        };

        $scope.customFullscreen = $mdMedia('xs') || $mdMedia('sm');
        $scope.slugDialog = function (ev) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$location',
                        function ($scope, $mdDialog, $location) {
                            $scope.hide = function () {
                                $mdDialog.hide();
                            };
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.answer = function (answer) {
                                $mdDialog.hide(answer);
                            };
                            $scope.go = function (path) {
                                $location.path(path);
                            };
                        }],
                    templateUrl: 'views/dialog-check-slug.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        };

        $scope.$on('msAuthenticated', function () {
            $scope.isAdmin = $scope.$root.userData.admin;
            site.raw('pages?fields=domain,settings', function (result) {
                result.pages.forEach(function (page) {
                    $scope.pages.push(page);
                });
            });
        });

    }]);


app.service('UploadQueue', ['$http', 'messages', 'site', '$rootScope', function ($http, messages, site, $rootScope) {

    var image_upload_queue_id = 0, image_upload_queue = [];

    /*
     edit image: on element left add image to queue (use image queue id)
     new image: add image to queue (use image queue id)
     image queue: upload image remove queue_id set content to img-url
     */
    function get_queue_item(queue_id) {
        for (var i = 0; i < image_upload_queue.length; i++) {
            var item = image_upload_queue[i];
            if (item.id == queue_id) return item;
        }
        return null;
    }

    function remove_queue_item(queue_id) {
        for (var i = 0; i < image_upload_queue.length; i++) {
            if (image_upload_queue[i].id == queue_id) return image_upload_queue.splice(i, 1);
        }
    }

    function upload_image(item) {
        /*if (imageSlot.settings && imageSlot.settings.image_file_name) {
         payload.file_name = imageSlot.settings.image_file_name; // TODO
         method = 'put';*/

        var payload = {
            domain: site.domain(),
            data: item.image_data
        };

        site.post('upload', payload, function (data/*, status*/) {
            item.queue_id_object[item.queue_id_field] = null; // TODO check id
            item.content_object[item.content_field] = '/uploads/' + data.domain + '/' + data.file_name + '?t=' + Math.random();
            item.content_object.settings.image_file_name = data.file_name;
            item.content_object.uploading = false; // TODO

            $rootScope.$broadcast('msImageSlotUploadingFinished');
            messages.notify('upload-finished');
            remove_queue_item(item.id);

        }, function (/*data, status*/) {
            // todo: log server error
            item.queue_id_object[item.queue_id_field] = null; // TODO check id
            item.content_object[item.content_field] = ''; // todo reset to default image
            item.content_object.uploading = false;

            $rootScope.$broadcast('msImageSlotUploadingFailed');
            messages.notify('upload-failed');
            remove_queue_item(item.id);
        });
    }


    var obj;
    obj = {
        getImage: function (queue_id) {
            var item = get_queue_item(queue_id);
            if (item) return item.image_data;
            return null;
        },

        /**
         * @param image_data {*} - the image data
         * @param queue_id_object {Object} -
         * @param queue_id_field {String} -
         * @param content_object {Object} -
         * @param content_field {String} -
         * @return {number}
         */
        addUpload: function (image_data, queue_id_object, queue_id_field, content_object, content_field) {
            image_upload_queue_id += 1;
            var item = {
                id: image_upload_queue_id,
                image_data: image_data,
                queue_id_object: queue_id_object,
                queue_id_field: queue_id_field,
                content_object: content_object,
                content_field: content_field
            };
            // todo console.debug("###START UPLOADING###", item)
            upload_image(item);
            image_upload_queue.push(item);
            return image_upload_queue_id;
        },
        cancel: function (queue_id) {

        }
    };
    return obj;
}]);

app.service('site', ['$templateCache', '$compile', '$http', '$animate', 'messages', '$location', 'msAuth', function ($templateCache, $compile, $http, $animate, messages, $location, msAuth) {
    var $scope;

    function hashify(str) {
        var hash = 0, i, chr, len;
        if (!str || str.length === 0) return hash;
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            //hash  = ((hash << 5) - hash) + chr;
            hash += chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    function replacer(key, value) {
        if (key && typeof key === 'string' && (key === "edit" || key.substr(0, 1) === "$")) {
            return undefined;
        }
        return value;
    }

    var hashOfInitialState = null;

    function saveStateOfPageData() {
        var s = JSON.stringify($scope.site, replacer);
        hashOfInitialState = hashify(s);
    }

    // TODO: show only on edit page
    window.onbeforeunload = function (e) {
        if (!$scope || !$scope.site) return undefined;
        var s = JSON.stringify($scope.site, replacer);

        if (hashOfInitialState !== null && hashOfInitialState !== hashify(s)) {
            // TODO: test on all browser!
            e.returnValue = "Du hast ungespeicherte Änderungen. Änderungen verwerfen?";
            return "Du hast ungespeicherte Änderungen. Änderungen verwerfen?";
        }

        return undefined;
    };
    window.addEventListener('beforeunload', window.onbeforeunload);

    var self = {
        domain: function () {
            return $scope.domain;
        },

        init: function (scope) {
            $scope = scope;
        },

        raw: function (uri, on_success, on_error) {
            $http.get('/api/' + uri, msAuth.request_auth_headers()).success(on_success).error(on_error || angular.noop);
        },
        post: function (url, payload, on_success, on_error) {
            $http.post('/api/' + url, payload, msAuth.request_auth_headers()).success(on_success).error(on_error || angular.noop);
        },

        delete_page: function (domain, on_success, on_error) {
            $http.delete('/api/page/' + domain, msAuth.request_auth_headers()).success(on_success).error(on_error || angular.noop);
        },

        load: function () {
            $animate.enabled(false);

            function siteLoaded(data) {
                $scope.site = data;// merge?
                saveStateOfPageData();
                if (!$scope.site.header) $scope.site.header = {settings: {}};
                if (!$scope.site.footer) $scope.site.footer = {settings: {}};
                $scope.sections = $scope.site.sections;
                $scope.header = $scope.site.header;
                $scope.footer = $scope.site.footer;
                $scope.msExt.siteLoaded($scope, document);
                self.autoSaveTrigger();
                setTimeout(function () {
                    $animate.enabled(true);
                }, 500);
            }

            $http.get('/api/page/' + $scope.domain, msAuth.request_auth_headers()).success(function (data/*, status, headers, config*/) {
                siteLoaded(data);

                // use site name as page title
                // todo: direct use in template (app.html)
                var siteName = '';
                if ($scope.site.settings && $scope.site.settings.address && $scope.site.settings.address.name && $scope.site.settings.address.name !== '')
                    siteName = $scope.site.settings.address.name;
                if (siteName !== '')
                    document.title = siteName + ' | ' + document.title;

            }).error(function (data/*, status, headers, config*/) {

                // no access rights
                if (data && data.message && data.message.toLowerCase() == 'insufficient permissions.') {
                    $animate.enabled(true);
                    $location.path('/dashboard/');
                    return;
                }

                // load default page & create
                $http.get('data/default.json').success(function (data) {
                    siteLoaded(data);
                    $scope.domain = $scope.domain.toLowerCase();
                    $scope.site.domain = $scope.domain;

                    // create page
                    $http.post('/api/page/' + $scope.domain, $scope.site, msAuth.request_auth_headers()).success(function (data) {
                        $scope.site.domain = data.domain.toLowerCase();
                        messages.notify('created-site-success');
                        self.autoSaveTrigger();

                    }).error(function (/*data, status*/) {
                        // todo: log error
                        $scope.site.domain = '';
                        messages.notify('created-site-failed');
                    });
                });
            });
        },

        autoSaveInterval: 3000 * 60, // every three minutes
        _autoSaveTimerRef: 0,

        autoSaveTrigger: function () {
            self._autoSaveTimerRef && clearTimeout(self._autoSaveTimerRef);
            self._autoSaveTimerRef = setTimeout(function () {
                var s = JSON.stringify($scope.site, replacer);
                if (hashOfInitialState !== null && hashOfInitialState !== hashify(s)) { // TODO testing!!
                    self.save();
                }
                self.autoSaveTrigger();
            }, self.autoSaveInterval);
        },

        save: function () {
            $scope.inSaveAction = true;
            var done = function (failed/*, status, data*/) {
                setTimeout(function () {
                    if (failed) {
                        messages.notify('saved-site-failed');
                    } else {
                        saveStateOfPageData();
                        //messages.notify('saved-site-success');
                    }
                    $scope.inSaveAction = false;
                    $scope.$applyAsync();
                }, 500);
            };

            // todo: pre/post save hooks
            $scope.editing._stashSelection();
            var raw_data = angular.copy($scope.site);
            $scope.editing._pop_selection();

            if ($scope.site.domain == $scope.domain) {
                $http.put('/api/page/' + $scope.domain, raw_data, msAuth.request_auth_headers()).success(function (data, status) {
                    done(false, status, data);
                }).error(function (data, status) {
                    done(true, status, data);
                }).finally(function () {
                    raw_data = null; // support gc
                });
            } else {
                $scope.site.domain = $scope.domain;
                $http.post('/api/page/' + $scope.domain, raw_data, msAuth.request_auth_headers()).success(function (data/*, status*/) {
                    $scope.site.domain = data.domain;
                    done();
                }).error(function (/*data, status*/) {
                    // todo: log server error
                    $scope.site.domain = '';
                    done(true);
                }).finally(function () {
                    raw_data = null; // support gc
                });
            }
        },

        preview: function () {
            $scope.save();
            $('.preview-overlay').removeClass('hidden');
            $('.preview-overlay iframe').attr('src', '/site/' + $scope.domain);
        },

        publish: function (callback) {
            var linkFn = $compile($templateCache.get('view.html'));
            var subScope = $scope.$new(true, $scope);
            $scope.site.settings.published = true;
            $scope.save(); // TODO
            subScope.msExt = $scope.msExt;
            subScope.sections = $scope.sections;
            subScope.site = $scope.site;
            subScope.header = $scope.header;
            subScope.footer = $scope.footer;
            subScope.mode = {edit: false};
            subScope.inPublishAction = true;
            $scope.viewFunction.forEach(function (key) {
                subScope[key] = $scope[key];
            });
            subScope.editing = $scope.editing;
            subScope.domain = $scope.domain;
            subScope.domainParts = $scope.domainParts;
            var content = linkFn(subScope);
            subScope.msExt.siteLoaded(subScope, content[0], true);

            var host = window.location.host;
            if (host.toLowerCase().substr(0, 4) == 'www.') host = host.substr(4);

            setTimeout(function () {
                self.generateThumbnail(function (canvas) {
                    var html = '';
                    for (var i = 0; i < content.length; i++) {
                        if (content[i].children && content[i].children.length > 0) {
                            html += content[i].outerHTML;
                        }
                    }
                    var payload = {
                        html: html,
                        thumbnail: canvas.toDataURL(),
                        bodyClasses: document.body.classList + '',
                        title: $scope.site.settings.address.name
                    };

                    var urlOfPublishedSite;
                    var hostname = document.location.hostname;
                    var isLocal = hostname === 'localhost' || hostname.substring(0, 7) === '192.168';

                    if (isLocal) {
                        urlOfPublishedSite = '/site/' + $scope.domain;
                    } else {
                        urlOfPublishedSite = 'http://' + $scope.domain + '.' + host;
                    }

                    $http.post('/api/page/publish/' + $scope.domain, payload, msAuth.request_auth_headers()).success(function () {
                        messages.custom('publish-site-success', {}, 6000, {'url': urlOfPublishedSite}, 'toasts/page-published.html');
                        if (callback) {
                            callback(true);
                        }
                    }).error(function () {
                        messages.notify('publish-site-failed');

                        if (callback) {
                            callback(false);
                        }
                    });
                    content.remove();
                    subScope.$destroy();
                });
            }, 1000);
        },

        account: function () {
            $scope.toggleRight();
        },

        /**
         * Apply several adjustments before taking a screenshot
         * @param clonedWindowDocument
         */
        prepareScreenshot: function (clonedWindowDocument) {
            // remove inline style of body element (added by md-dialog)
            var body = clonedWindowDocument.querySelector('body');
            angular.forEach(body.style, function (styleProperty) {
                body.style.removeProperty(styleProperty);
            });

            var ps = clonedWindowDocument.querySelectorAll('p');
            angular.forEach(ps, function (p) {
                p.style.height = p.getBoundingClientRect().height + 'px';
                p.style.overflow = 'hidden';
            });

            clonedWindowDocument.getElementById('sidebar-ctrl').style.overflow = '';
        },

        /**
         * Remove GUI elements that should not be visible on screenshot
         * @param clonedWindowDocument
         */
        prepareScreenshotAndRemoveGuiElements: function (clonedWindowDocument) {

            self.prepareScreenshot(clonedWindowDocument);

            var guiElements = [
                '.preview-overlay',
                '.md-dialog-container',
                '.md-scroll-mask',
                '.md-select-backdrop',
                '.md-dialog-backdrop',
                '.md-select-menu-container',
                '.section-handler',
                '#speed-dial',
                '.ms-tutor-wrap',
                '.group-separator',
                '.feedbackbutton'
            ];
            guiElements = clonedWindowDocument.querySelectorAll(guiElements.join());
            angular.forEach(guiElements, function (guiElement) {
                angular.element(guiElement).remove();
            });
        },

        takeScreenshot: function (width, height, callback) {
            var target = document.body;

            html2canvas(target, {onclone: this.prepareScreenshotAndRemoveGuiElements}).then(function (canvas) {
                var resizedCanvas = document.createElement('canvas');
                resizedCanvas.width = width;
                resizedCanvas.height = height;

                var contentWidth = $('main .container:first-child').outerWidth();
                var offsetX = ($(window).width() - contentWidth) / 2;

                resizedCanvas.getContext("2d").drawImage(canvas, offsetX, 0, contentWidth, resizedCanvas.height / resizedCanvas.width * contentWidth, 0, 0, resizedCanvas.width, resizedCanvas.height);

                // clean big canvas
                canvas.height = 0;
                canvas.width = 0;

                callback(resizedCanvas);
            });
        },

        generateThumbnail: function (callback) {
            // todo: replace fixed values
            return this.takeScreenshot(300, 210, callback);
        },
        /**
         * @returns {msSection[]}
         */
        getSections: function () {
            return $scope.sections;
        }
    };

    return self;
}]);


app.controller('myCtrl', ['$scope', 'site', '$location', '$animate', '$routeParams', 'EditingService', 'msExt', '$mdSidenav', '$mdBottomSheet', 'messages', 'colors', 'msAuth', '$route', '$sce',
    function ($scope, site, $location, $animate, $routeParams, EditingService, msExt, $mdSidenav, $mdBottomSheet, messages, colors, msAuth, $route, $sce) {
        /** @type {msSite} */
        $scope.site = {};
        /** @type {[msSection]} */
        $scope.sections = [];
        /** @type {[string]} */
        $scope.domainParts = ($routeParams.domain + '').split('/');
        /** @type {string} */
        $scope.domain = $scope.domainParts[0].toLowerCase();
        $scope.mode = {edit: false};
        if ($scope.domainParts[$scope.domainParts.length - 1] == 'edit') {
            $scope.mode.edit = true;
            $scope.domainParts.pop();
        }
        site.init($scope);
        $scope.device = document.documentElement.classList.contains('desktop') ? 'desktop' : 'mobile';

        $scope.publishClicked = false;

        $scope.publishClickedInToolbar = function () {
            $scope.publishClicked = true;
            $scope.publish(function (published) {
                setTimeout(function () {
                    $scope.publishClicked = false;
                    $scope.$apply();
                }, 4000);
            });
        };

        window.scope = $scope; // debug code

        $scope.navPreventReload = function () {
            var lastRoute = $route.current;
            var un = $scope.$root.$on('$locationChangeSuccess', function () {
                $route.current = lastRoute;
                un();
            });
        };

        $scope.$on('msAuthenticated', function () {
            site.load();
        });
        $scope.save = site.save;
        $scope.preview = site.preview;
        $scope.publish = site.publish;
        $scope.account = site.account;
        $scope.msSite = site;

        /** @param group {msGroup} */
        $scope.groupClass = function (group) {
            var out = '';
            if (group.slots.length >= 6 && ($scope.editing.last_group != group || $scope.editing.mode != 'cut')) out += 'row-full';

            if (group.settings && group.settings.classes) {
                out += ' ' + group.settings.classes.join(' ');
            }
            return out;
        };

        /**
         * @param group {msGroup}
         * @param slot {msSlot}
         * @returns {string}
         */
        $scope.calcSlotClass = function (group, slot) {
            var width = 12 / (group.slots.length) | 0;
            if (width < 2) width = 2;
            var colClasses = '';
            switch (width) {
                case 12: // 1 column
                    colClasses = ' col-sm-12';
                    break;
                case 6: // 2 columns
                    colClasses = ' col-sm-6';
                    break;
                case 4: // 3 columns
                    colClasses = ' col-sm-6 col-md-4';
                    break;
                case 3: // 4 columns
                    colClasses = ' col-sm-6 col-md-4 col-lg-3';
                    break;
                case 2: // 6 columns
                    colClasses = ' col-sm-6 col-md-4 col-lg-2';
                    break;
                default: // 1 column
                    colClasses = ' col-sm-12';
            }

            if (group.slots.length == 5) { // 5 columns
                colClasses = ' col-xs-5ths col-sm-5ths col-md-5ths';
            }

            var classes = 'slot';
            classes += colClasses + ' type-' + slot.type;

            if (slot.settings && slot.settings.classes) {
                classes += ' ' + slot.settings.classes.join(' ');
            }

            if (slot.edit) {
                classes += ' edit-slot';
            }
            return classes;
        };

        $scope.addSlotContentClasses = function (element) {
            var slotContentClasses = [];
            if (element.settings &&
                element.settings.styles &&
                element.settings.styles['bg-color'] &&
                element.settings.styles['bg-color'] !== '') {
                slotContentClasses.push('has-bg-color');
            }
            return slotContentClasses;
        };

        /**
         * @param element {msSite|msSection|msSlot}
         * @param type {string}
         * @returns {{}|undefined}
         */
        $scope.addInlineStyle = function (element, type) {
            if (!element) return;
            var inlineStyles = {};
            if (element.settings && element.settings.styles) {
                var styles = element.settings.styles;

                if (styles['bg-image']) {
                    inlineStyles['background-image'] = 'url("' + styles['bg-image'] + '")';
                    inlineStyles['background-position'] = '50% 50%';
                    if (type !== 'header' && type !== 'footer') inlineStyles['background-size'] = 'cover';
                } else if (styles['bg-color'] && styles['bg-color-second']) {
                    var hex1 = '#' + colors.hex(styles['bg-color']);
                    var hex2 = '#' + colors.hex(styles['bg-color-second']);
                    inlineStyles['background-color'] = hex1;
                    inlineStyles['background'] = 'linear-gradient(to bottom,' + hex1 + ' 0%,' + hex2 + ' 100%)';
                } else if (styles['bg-color']) {
                    var opacity = styles['bg-opacity'] ? styles['bg-opacity'] : 100;
                    if (opacity > 1 && opacity != 100) {
                        inlineStyles['background-color'] = colors.rgba(styles['bg-color'], opacity);
                    } else if (opacity !== 0) {
                        inlineStyles['background-color'] = colors.rgb(styles['bg-color']);
                    }
                }
                if (styles['color']) {
                    inlineStyles['color'] = '#' + colors.hex(styles['color']);
                }
            }
            return inlineStyles;
        };
        $scope.addInlinePadding = function (element, type) {
            if (!element) return;
            var inlineStyles = {};
            if (element.settings && element.settings.styles) {
                var styles = element.settings.styles;

                if (styles['field-padding']) {
                    var padding = styles['field-padding'] ? styles['field-padding'] : 100;
                    if (padding > 1 && padding != 100) {
                        inlineStyles['padding'] = padding + 'px 0';
                    } else if (padding !== 0) {
                        inlineStyles['padding'] = '0';
                    }
                }
            }
            return inlineStyles;
        };
        $scope.setNavbarStatic = function (settings) {
            if (settings.classes.indexOf('nav-height-full') >= 0 && settings.classes.indexOf('navbar-fixed-top') >= 0) {
                settings.classes.splice(settings.classes.indexOf('navbar-fixed-top'), 1, 'navbar-static-top');
            }
        };
        $scope.trustResource = function (resource) {
            return $sce.trustAsResourceUrl(resource);
        };
        $scope.getHeaderVideo = function (settings) {
            if (settings && settings.video && settings.video.url) {
                var autoplay = settings.video.autoplay ? 1 : 0;
                var url = settings.video.url + '?autoplay=' + autoplay + '&loop=1&showinfo=0&controls=0';
                return $scope.trustResource(url);
            }
        };
        $scope.setHeaderBg = function (header, prop) {

            var showImage = !!(header.settings.showImage);
            var showVideo = !!(header.settings.showVideo);

            if (showImage && showVideo) {

                if (prop === 'image') {
                    hideProperty('video');
                    showProperty('image');

                } else if (prop === 'video') {
                    hideProperty('image');
                    showProperty('video');
                }
            } else {
                if (showImage) {
                    hideProperty('video');
                    showProperty('image');

                } else if (showVideo) {
                    hideProperty('image');
                    showProperty('video');

                } else {
                    hideProperty('image');
                    hideProperty('video');
                }
            }

            function showProperty(prop) {
                if (prop === 'image') {
                    header.settings.showImage = true;
                    if (!header.settings.styles['bg-image'] || header.settings.styles['bg-image'] === '') {
                        header.settings.styles = {
                            'bg-image': '/img/bg-patterns/swirl_pattern.png'
                        };
                    }
                } else if (prop === 'video') {
                    header.settings.showVideo = true;
                    if (!header.settings.video) {
                        header.settings.video = {
                            'url': 'https://www.youtube.com/embed/SYRlTISvjww'
                        };
                    }
                }
            }

            function hideProperty(prop) {
                if (prop === 'image') {
                    header.settings.showImage = false;
                    if (header.settings.styles['bg-image']) delete header.settings.styles['bg-image'];
                    if (header.settings.styles['_bg-image']) delete header.settings.styles['_bg-image'];
                } else if (prop === 'video') {
                    header.settings.showVideo = false;
                    if (header.settings.video) delete header.settings.video;
                }
            }
        };
        $scope.setFooterProps = function (footer, group, prop) {
            if (group === 'bg') {
                var showImage = !!(footer.settings.showImage);
                if (prop === 'pattern') footer.settings.bgImage = false;
                if (prop === 'image') footer.settings.bgPattern = false;
                if (showImage) {
                    footer.settings.showImage = true;
                    if (!footer.settings.styles['bg-image'] || footer.settings.styles['bg-image'] === '') {
                        footer.settings.styles['bg-image'] = '/img/bg-patterns/dark/default.png';
                    }
                } else {
                    footer.settings.showImage = false;
                    footer.settings.bgPattern = false;
                    footer.settings.bgImage = false;
                    if (footer.settings.styles['bg-image']) delete footer.settings.styles['bg-image'];
                }
            }
        };
        $scope.addNavClasses = function (header) {
            var navClasses = [];
            if (header && header.settings && header.settings.classes) {

                var body = document.body;
                var navbar = document.getElementById('navbar-main');

                var validBodyClasses = [
                    'nav-height-sm',
                    'nav-height-md',
                    'nav-height-lg',
                    'nav-height-full',
                    'navbar-static-top',
                    'navbar-fixed-top'
                ];
                var validNavClasses = [
                    'navbar-static-top',
                    'navbar-fixed-top',
                    'nav-align-vertical-top',
                    'nav-align-vertical-middle',
                    'nav-align-vertical-bottom',
                    'logo-align-horizontal-left',
                    'logo-align-horizontal-center',
                    'logo-align-horizontal-right'
                ];

                validBodyClasses.forEach(function (className) {
                    if (angular.element(body).hasClass(className))
                        angular.element(body).removeClass(className);
                });

                header.settings.classes.forEach(function (className) {
                    if (validBodyClasses.indexOf(className) >= 0) {
                        angular.element(body).addClass(className);
                    }
                    if (validNavClasses.indexOf(className) >= 0) {
                        navClasses.push(className);
                    }
                });
            }
            return navClasses;
        };

        $scope.addNavbarClasses = function (header) {
            var navbarClasses = [];
            if (header && header.settings && header.settings.classes) {
                var validNavbarClasses = [
                    'navbar-left',
                    'navbar-center',
                    'navbar-right'
                ];
                header.settings.classes.forEach(function (className) {
                    if (validNavbarClasses.indexOf(className) >= 0) {
                        navbarClasses.push(className);
                    }
                });
            }
            return navbarClasses;
        };

        $scope.viewFunction = ['groupClass', 'calcSlotClass', 'addSlotContentClasses', 'addInlineStyle',
            'addInlinePadding', 'setNavbarStatic', 'trustResource', 'getHeaderVideo', 'setHeaderBg', 'setFooterProps',
            'addNavClasses', 'addNavbarClasses', 'inheritStyle', 'StylesHasKey'];

        /**
         * @param section {msSection}
         * @param slot {msSlot}
         * @param isNav
         * @returns {{}}
         */
        $scope.inheritStyle = function (section, slot, isNav) {

            var type = false;
            if (isNav)
                type = 'nav';
            else if (slot && slot.type)
                type = slot.type;

            if (type) {

                var fontFamily = getInheritedStyle(section, slot, 'font-family', type);
                var fontSize = getInheritedStyle(section, slot, 'font-size', type);
                var color = getInheritedStyle(section, slot, 'color', type);

                var styles = {};
                if (fontFamily && fontFamily !== undefined)
                    styles['font-family'] = fontFamily;
                if (fontSize && fontSize !== undefined)
                    styles['font-size'] = fontSize;
                if (color && color !== undefined)
                    styles['color'] = '#' + color;

                return styles;
            }

            function getInheritedStyle(section, slot, prop, type) {

                var key = prop + '-' + type;
                if (slot && slot.settings && slot.settings.styles && slot.settings.styles[key]) {
                    return slot.settings.styles[key];

                } else if (section && section.settings && section.settings.styles && section.settings.styles[key]) {
                    return section.settings.styles[key];

                } else if ($scope.site.settings && $scope.site.settings.styles && $scope.site.settings.styles[key]) {
                    return $scope.site.settings.styles[key];
                }
            }
        };

        $scope.editing = EditingService.initialize($scope);
        $scope.msExt = msExt.initialize();
        $scope.messages = messages;

        $scope.toggleLeft = function () {
            if ($scope.mode.edit) {
                $mdSidenav('left').toggle();
            }
        };
        $scope.toggleLeftAllowed = function () {
            var result = true;
            if ($scope.editing.slot) {
                if (['spacer'].indexOf($scope.editing.slot.type) != -1) {
                    result = false; // disable config button for these slots
                }
            } else if ($scope.editing.group) {
                result = false; // groups have no configurations
            }
            return result;
        };
        $scope.toggleRight = function () {
            if ($scope.mode.edit) {
                $mdSidenav('right').toggle();
            }
        };

        $scope.sectionLabelDbClick = function (section, $event) {
            if (!$scope.mode.edit) return;
            if (!section.edit) {
                EditingService.onSectionLabelClick(section, $event)
            }
            $scope.openConfig('section');
        };

        $scope.openConfig = function (param) {
            if (!$scope.mode.edit) return;
            setTimeout(function () {
                $scope.$root.$broadcast('msOpenLeftSidebar', param);
            }, 32);
        };

        $scope.userSawAlert = false;
        $scope.showGridBottomSheet = function ($event, skipUserInteraction, on_add) {
            messages.show('bottom-sheet');
            document.body.classList.add('overflow-hidden');
            return $mdBottomSheet.show({
                templateUrl: 'bottom-sheet.html',
                controller: 'GridBottomSheetCtrl',
                targetEvent: $event
            }).then(function (clickedItem) {
                if (!clickedItem) return;

                $scope.$root.$broadcast('bottom-sheet-clicked', clickedItem);

                if (clickedItem.type == 'section') {
                    $scope.editing.switchMode('addSection');

                } else if (clickedItem.type == 'group') {
                    $scope.editing.switchMode('addGroup');

                } else {
                    /** @type {*|msSlot} */
                    var newSlot = {type: clickedItem.type, content: clickedItem.default};

                    angular.forEach($scope.editing.detectedSlots, /** @param customSlot {msDynamicSlot} */ function (customSlot) {
                        if (customSlot.name == clickedItem.type + 'Slot' && customSlot.service && customSlot.service.initializeSlot) {
                            customSlot.service.initializeSlot(newSlot, $scope);
                        }
                    });

                    $scope.editing.switchMode('addSlot', newSlot);
                    if (on_add) on_add();
                }

                if (skipUserInteraction === false && $scope.userSawAlert === false) {
                    $scope.userSawAlert = true;
                }

                if (skipUserInteraction) {
                    $scope.editing.handleWithLastSelection();
                }
            }).finally(function () {
                $scope.$root.$broadcast('bottom-sheet-closed');
                messages.hide();
                document.body.classList.remove('overflow-hidden');
            });
        };
        $scope.$root.showGridBottomSheet = $scope.showGridBottomSheet;

        //msShare.msShareStart($scope, $http, 750);

        $scope.StylesHasKey = function (obj, key) {
            return (obj.settings && obj.settings.styles && obj.settings.styles.hasOwnProperty(key));
        };
    }]);

app.controller('Shell', ['$mdSidenav', '$scope', '$mdDialog', function ($mdSidenav, $scope, $mdDialog) {
    /**
     * move x icons from 'hidden' to 'show' array
     * @param count
     */
    function showItems(count) {
        for (var i = 0; i < count; i++) {
            if ($scope.items.hidden.length) {
                var element = $scope.items.hidden.shift();
                $scope.items.visible.push(element);
            } else {
                break;
            }
        }
    }

    $scope.$mdSidenav = $mdSidenav;

    /**
     * move x icons from 'show' to 'hidden' array
     * @param count
     */
    function hideItems(count) {
        for (var i = 0; i < count; i++) {
            if ($scope.items.visible.length) {
                var element = $scope.items.visible.pop();
                $scope.items.hidden.unshift(element);
            } else {
                break;
            }
        }
    }

    $scope.items = {
        visible: [
            {
                icon: 'settings',
                label: 'Einstellungen',
                callback: $scope.toggleLeft,
                disabled: function () {
                    return !$scope.toggleLeftAllowed();
                }
            },
            {
                icon: 'content_cut',
                label: 'Ausschneiden',
                callback: function () {
                    $scope.editing.switchMode('cut');
                }
            },
            {
                icon: 'content_copy',
                label: 'Kopieren',
                callback: function () {
                    $scope.editing.switchMode('copy');
                }
            },
            {
                icon: 'delete',
                label: 'Löschen',
                callback: function () {
                    $scope.editing.remove();
                }
            },
            {
                icon: 'add',
                label: 'Hinzufügen',
                callback: function ($event) {
                    if ($scope.editing.group && $scope.editing.group.slots.length > 5) {
                        var confirm = $mdDialog.confirm()
                            .title('Zeile bereits Voll')
                            .content('Soll der Slot in einer neuen Zeile eingefügt werden?')
                            .targetEvent($event)
                            .ok('Zeile einfügen').cancel('Abbrechen');
                        $mdDialog.show(confirm).then(function () {
                            $scope.showGridBottomSheet($event, true, function () {
                                console.log($scope.editing.last_section, $scope.editing.last_group, $scope.editing.last_slot);
                                $scope.editing.last_group = $scope.editing._insertGroup($scope.editing.last_section, $scope.editing.last_group, $scope.editing.last_group.slots.length, true);
                                $scope.editing.last_slot = null;
                            });
                        });
                    } else {
                        $scope.showGridBottomSheet($event, true);
                    }
                }
            }
        ],
        hidden: []
    };

    var recalculate = function (newWidth) {
        // 2 for: "more" and "close" button
        var spaceLeftInPx = ($scope.items.visible.length + 2) * buttonWidth;
        var freeSlots = Math.floor((newWidth - spaceLeftInPx) / buttonWidth);

        if (freeSlots > 0) {
            showItems(freeSlots);
        } else if (freeSlots < 0) {
            hideItems(freeSlots * -1);
        }
    };

    $scope.$watch('editing.slot_options', function (/*newWidth*/) {
        var newOptions = $scope.editing.slot_options;

        // clear old slot options
        var y;

        for (y = 0; y < $scope.items.visible.length; y++) {
            if ($scope.items.visible[y].slot_option) {
                if ($scope.items.visible[y].shortcut) {
                    $scope.editing.unregisterShortcut($scope.items.visible[y].shortcut);
                }
                $scope.items.visible.splice(y, 1);
                y--;
            }
        }

        for (y = 0; y < $scope.items.hidden.length; y++) {
            if ($scope.items.hidden[y].slot_option) {
                if ($scope.items.hidden[y].shortcut) {
                    $scope.editing.unregisterShortcut($scope.items.hidden[y].shortcut);
                }
                $scope.items.hidden.splice(y, 1);
                y--;
            }
        }

        // add new
        for (var x = 0; x < newOptions.length; x++) {
            var found = false;

            // already there as visible icons?
            for (var z = 0; z < $scope.items.visible.length; z++) {
                if (newOptions[x].icon == $scope.items.visible[z].icon) {
                    found = true;
                    break;
                }
            }

            // already there as hidden icons (menu)?
            for (var v = 0; v < $scope.items.hidden.length; v++) {
                if (newOptions[x].icon == $scope.items.hidden[v].icon) {
                    found = true;
                    break;
                }
            }

            // not found -> add it
            if (!found) {
                if (newOptions[x].shortcut) {
                    $scope.editing.registerShortcut(newOptions[x].shortcut, newOptions[x].callback);
                }
                newOptions[x].slot_option = true; // mark as slot option
                $scope.items.hidden.push(newOptions[x]);
            }
        }

        // trigger to apply changes on view
        recalculate($scope.windowWidth);
    });

    // todo: try to get the width of an icon dynamically
    var buttonWidth = 58;

    // windowWidth is set by resize-directive
    $scope.$watch('windowWidth', recalculate);
}]);


app.service('bottomSheetItems', [function () {
    return {
        visible: [
            {name: 'Text', 'type': 'text', icon: 'border_color', 'default': 'Schreiben Sie einfach drauf los...'},
            {name: 'Bild', 'type': 'image', icon: 'photo', 'default': '/img/default/image-placeholder-16-9.png'},
            //{name: 'Zitat', 'type': 'quote', icon: 'format_quote', 'default': 'Do what’s right, not what’s easy…'},
            {name: 'YouTube Video', 'type': 'youtube', icon: 'play_arrow', 'default': ''},
            {name: 'Abschnitt', 'type': 'section', icon: 'check_box_outline_blank'},
            {name: 'Zeilenumbruch', 'type': 'group', icon: 'keyboard_return'}

        ],
        hidden: [
            {name: 'Headline', 'type': 'headline', icon: 'view_headline', 'default': 'Headline'},
            {name: 'Platzhalter', 'type': 'spacer', icon: 'fullscreen', 'default': ''},
            {name: 'Adresse', 'type': 'address', icon: 'location_on', 'default': ''},
            {name: 'Social Media', 'type': 'socialmedia', icon: 'share', 'default': ''}
        ],
        disabled: [
            // contains a list of items (strings!) that are shown disabled
            // the field 'type' of items is used as value
            // 'show-more' is an exception because its not an item
        ]
    };
}]);

app.controller('GridBottomSheetCtrl', ['$scope', '$mdBottomSheet', '$timeout', 'bottomSheetItems', function ($scope, $mdBottomSheet, $timeout, bottomSheetItems) {
    $scope.items = bottomSheetItems;

    $scope.showMoreButton = true;
    $scope.showMore = false;

    $scope.loadAdditional = function () {
        $scope.showMoreButton = false;

        // todo: it jumps up and down because items + additional items + more button generates sometimes more rows than needed
        // todo: bug: additional items are shown before the more button hidden...
        $timeout(function () {
            $scope.showMore = true;
        }, 800);
    };

    $scope.listItemClick = function ($index, hiddenOrVisible) {
        var clickedItem = $scope.items[hiddenOrVisible][$index];
        $mdBottomSheet.hide(clickedItem);
    };

    // expose api
    $scope.$root.bottomsheetItems = $scope.items;
    $scope.$evalAsync(function () {
        $scope.$root.$broadcast('bottom-sheet-opened');
    });
}]);


app.controller('SidebarCtrl', ['$scope', '$mdSidenav', 'OptionSidebar', 'messages', 'slugify', '$rootScope', function ($scope, $mdSidenav, OptionSidebar, messages, slugify, $rootScope) {
    $scope.messages = messages;
    $scope.optionSidebar = OptionSidebar;
    window.scope2 = $scope;

    /** @type {msSite|msSection|msGroup|msSlot} */
    $scope.subject = null;

    /**
     * validation for section title
     *
     * @param {string} value
     * @return {boolean}
     */
    $scope.isSectionTitleUnique = function (value) {
        var found = 0;
        $scope.sections.forEach(function (section) {
            if (section.settings && section.settings.title == value) {
                found += 1;
            }
        });
        return found == 1;
    };

    // wait for the site object to be loaded.
    // todo replace by siteLoaded event
    var destructor = $scope.$watch('site', function () {
        if ($scope.site && $scope.site.sections) {
            $scope.subject = $scope.site;
            destructor();
        }
    });

    $scope.fontFamilies = [
        {key: 'roboto', value: '"Roboto", sans-serif', name: 'Roboto'},
        {key: 'opensans', value: '"Open Sans", sans-serif', name: 'Open Sans'},
        {key: 'josefin', value: '"Josefin Slab", serif', name: 'Josefin Slab'},
        {key: 'arvo', value: '"Arvo", serif', name: 'Arvo'},
        {key: 'lato', value: '"Lato", sans-serif', name: 'Lato'},
        {key: 'vollkorn', value: '"Vollkorn", serif', name: 'Vollkorn'},
        {key: 'ubuntu', value: '"Ubuntu", sans-serif', name: 'Ubuntu'},
        {key: 'ptsans', value: '"PT Sans", sans-serif', name: 'PT Sans'},
        {key: 'ptserif', value: '"PT Serif", serif', name: 'PT Serif'},
        {key: 'oldstandardtt', value: '"Old Standard TT", serif', name: 'Old Standard TT'},
        {key: 'droidsans', value: '"Droid Sans", sans-serif', name: 'Droid Sans'},
        {key: 'alegreya', value: '"Alegreya", serif', name: 'Alegreya'},
        {key: 'alegreya-sans', value: '"Alegreya Sans", sans-serif', name: 'Alegreya Sans'},
        {key: 'source-sans-pro', value: '"Source Sans Pro", sans-serif', name: 'Source Sans Pro'},
        {key: 'source-serif-pro', value: '"Source Serif Pro", serif', name: 'Source Serif Pro'},
        {key: 'lora', value: '"Lora", serif', name: 'Lora'},
        {key: 'karla', value: '"Karla", sans-serif', name: 'Karla'},
        {key: 'poppins', value: '"Poppins", sans-serif', name: 'Poppins'},
        {key: 'neuton', value: '"Neuton", serif', name: 'Neuton'},
        {key: 'merriweather', value: '"Merriweather", serif', name: 'Merriweather'},
        {key: 'roboto-slab', value: '"Roboto Slab", serif', name: 'Roboto Slab'},
        {key: 'anonymous-pro', value: '"Anonymous Pro"', name: 'Anonymous Pro'},
        {key: 'archivo-narrow', value: '"Archivo Narrow", sans-serif', name: 'Archivo Narrow'},
        {key: 'libre-baskerville', value: '"Libre Baskerville", serif', name: 'Libre Baskerville'},
        {key: 'crimson-text', value: '"Crimson Text", serif', name: 'Crimson Text'},
        {key: 'montserrat', value: '"Montserrat", sans-serif', name: 'Montserrat'},
        {key: 'chivo', value: '"Chivo", sans-serif', name: 'Chivo'},
        {key: 'domine', value: '"Domine", serif', name: 'Domine'},
        {key: 'varela-round', value: '"Varela Round", sans-serif', name: 'Varela Round'},
        {key: 'bitter', value: '"Bitter", serif', name: 'Bitter'},
        {key: 'cardo', value: '"Cardo", serif', name: 'Cardo'}
    ];

    $scope.fontSizesNav = [14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
    $scope.fontSizesHeadline = [20, 22, 24, 26, 28, 32, 40, 48, 56, 64, 72];
    $scope.fontSizesText = [12, 13, 14, 15, 16, 17, 18, 20, 22, 24];

    $scope.bgPatterns = [
        {key: 'binding_dark.png', name: 'Binding dark', path: '/img/bg-patterns/dark/'},
        {key: 'congruent_outline.png', name: 'Congruent Pentagon Outline', path: '/img/bg-patterns/dark/'},
        {key: 'dark_embroidery.png', name: 'Dark Embroidery', path: '/img/bg-patterns/dark/'},
        {key: 'footer_lodyas.png', name: 'Dark Sharp Edges', path: '/img/bg-patterns/dark/'},
        {key: 'grey_wash_wall.png', name: 'Grey Washed Wall', path: '/img/bg-patterns/dark/'},
        {key: 'simple_dashed.png', name: 'Simple Dashed', path: '/img/bg-patterns/dark/'},
        {key: 'slash_it.png', name: 'Slash it', path: '/img/bg-patterns/dark/'},
        {key: 'stardust.png', name: 'Stardust', path: '/img/bg-patterns/dark/'},
        {key: 'tweed.png', name: 'Tweed', path: '/img/bg-patterns/dark/'},
        {key: 'zwartevilt.png', name: 'Black Felt', path: '/img/bg-patterns/dark/'}
    ];

    $scope.updateSlug = function (section) {
        section.settings.slug = slugify(section.settings.title);
    };

    $scope.isTitleValid = function (section) {
        var valid = true;
        $scope.site.sections.forEach(function (sec) {
            if (sec != section && sec.settings && section.settings && sec.settings.title == section.settings.title) {
                valid = false;
            }
        });
        return valid;
    };

    /**
     * @param prop String - font-family|font-size|color
     * @param type {String} - nav|headline|text
     * @return {String}
     */
    $scope.inheritStyleI = function (prop, type) {
        var section = OptionSidebar.current_section;
        var slot = OptionSidebar.current_slot;

        var defaults = {
            "font-family-nav": "Roboto",
            "font-family-headline": "Roboto",
            "font-family-text": "Roboto",
            "font-size-nav": "16px",
            "font-size-headline": "26px",
            "font-size-text": "16px",
            "color-nav": "ffffff",
            "color-headline": "333333",
            "color-text": "333333"
        };

        if (slot) {
            return getInheritedStyle(section, prop, type);
        } else if (section) {
            return getInheritedStyle(null, prop, type);
        } else {
            return getInheritedStyle(null, prop, type, true);
        }

        function getPrettyName(value) {
            if (value.indexOf(',') >= 0)
                value = value.substring(0, value.indexOf(','));
            return value.replace(/"/g, '');
        }

        function getInheritedStyle(section, prop, type, showDefault) {
            var key = prop + '-' + type;
            if (section && section.settings && section.settings.styles && section.settings.styles[key]) {
                var sectionValue = (prop === 'font-family') ? getPrettyName(section.settings.styles[key]) : section.settings.styles[key];
                if (prop == 'color') return {text: "(von Abschnitt)", value: sectionValue};
                return sectionValue + " (von Abschnitt)";

            } else if (!showDefault && $scope.site.settings && $scope.site.settings.styles && $scope.site.settings.styles[key]) {
                var siteValue = (prop === 'font-family') ? getPrettyName($scope.site.settings.styles[key]) : $scope.site.settings.styles[key];
                if (prop == 'color') return {text: "(von Seite)", value: siteValue};
                return siteValue + " (von Seite)";

            } else {
                if (prop == 'color') return {text: "(Standard)", value: defaults[key]};
                return defaults[key] + " (Standard)"
            }
        }
    };

    /**
     * updates the sidebar context
     * @param {String} [key] - if key is given the sidebar try to load the config with the given key
     */
    function _updateSidebar(key) {
        if ($scope.editing.slot) {
            $scope.config_key = 'slot';
            $scope.subject = $scope.editing.slot;

        } else if ($scope.editing.group) {
            $scope.config_key = 'group';
            $scope.subject = $scope.editing.group;

        } else if ($scope.editing.section) {
            $scope.config_key = 'section';
            $scope.subject = $scope.editing.section;

        } else {
            $scope.config_key = 'site';
            $scope.subject = $scope.site;
        }
        OptionSidebar.switchContext($scope.subject, $scope.config_key, $scope.site, $scope.editing.section, $scope.editing.group, $scope.editing.slot);

        if (key) {
            OptionSidebar.visible_configurations.forEach(/** @param {msSidebarConfig} config */function (config) {
                if (config.key == key) {
                    OptionSidebar.selectConfiguration(config);
                }
            });
        }

        if ($scope.subject && !$scope.subject.settings) {
            $scope.subject.settings = {};
        }
        if ($scope.subject && !$scope.subject.settings.styles) {
            $scope.subject.settings.styles = {};
        }
        if ($scope.header.settings && !$scope.header.settings.styles)
            $scope.header.settings.styles = {};

        if ($scope.footer.settings && !$scope.footer.settings.styles)
            $scope.footer.settings.styles = {};
    }

    $scope.$on('msModeSwitched', _updateSidebar);
    $scope.$on('msModeHandled', _updateSidebar);
    $scope.$on('msExtFinished', _updateSidebar);

    /**
     * helper to open the sidebar
     * example: $scope.$broadcast('msOpenLeftSidebar', 'background'); to open the sidebar with the background-configuration
     */
    $scope.$on('msOpenLeftSidebar', function (key, param) {
        $mdSidenav('left').open();
        _updateSidebar(param);
    });

    $scope.StylesHasKey = function (obj, key) {
        return (obj.settings && obj.settings.styles && obj.settings.styles.hasOwnProperty(key));
    };

    /**
     * @param obj {msSlot|msSection|msSite}
     * @param key {string}
     * @param default_value {*}
     * @param [toggle_class] {string}
     */
    $scope.StylesToggleKey = function (obj, key, default_value, toggle_class) {

        if (!obj.settings) obj.settings = {};
        if (!obj.settings.styles) obj.settings.styles = {};
        if (!obj.settings.classes) obj.settings.classes = [];

        if (default_value === undefined)
            default_value = 'transparent';

        if (obj.settings.styles.hasOwnProperty(key)) {
            obj.settings.styles['_' + key] = obj.settings.styles[key];
            delete obj.settings.styles[key];
            if (toggle_class && obj.settings.classes.indexOf(toggle_class) >= 0) {
                obj.settings.classes.splice(obj.settings.classes.indexOf(toggle_class), 1);
            }
        } else {
            if (obj.settings.styles['_' + key]) default_value = obj.settings.styles['_' + key];
            obj.settings.styles[key] = default_value;
            if (toggle_class && obj.settings.classes.indexOf(toggle_class) == -1) {
                obj.settings.classes.push(toggle_class);
            }
        }
    };

    $scope.isOpen = function () {
        return $mdSidenav('left').isOpen();
    };
    $scope.close = function () {
        if ($mdSidenav('left').isOpen()) $mdSidenav('left').close();
        if ($mdSidenav('right').isOpen()) $mdSidenav('right').close();
    };

    $scope.logout = function () {
        $rootScope.msAuth.logout();
        window.location = '/';
    };
}]);

app.directive('msTooltip', MdTooltipDirective);
// TODO fix tooltips

function MdTooltipDirective($timeout, $$rAF, $mdUtil, $mdTheming, $animate) {
    var TOOLTIP_SHOW_DELAY = 0;
    var TOOLTIP_WINDOW_EDGE_SPACE = 8;

    return {
        restrict: 'E',
        transclude: true,
        priority: 210, // Before ngAria
        template: '<div class="md-content" ng-transclude></div>',
        scope: {
            delay: '=?mdDelay',
            visible: '=?mdVisible',
            autohide: '=?mdAutohide',
            direction: '@?mdDirection'    // only expect raw or interpolated string value; not expression
        },
        link: postLink
    };

    function postLink(scope, element, attr) {

        $mdTheming(element);

        var parent = $mdUtil.getParentWithPointerEvents(element),
            content = angular.element(element[0].getElementsByClassName('md-content')[0]),
            tooltipParent = angular.element(document.body),
            debouncedOnResize = $$rAF.throttle(function () {
                updatePosition();
            });

        if ($animate.pin) $animate.pin(element, parent);

        // Initialize element

        setDefaults();
        manipulateElement();

        // Default origin transform point is 'center top'
        // positionTooltip() is always relative to center top
        updateContentOrigin();

        configureWatchers();
        addAriaLabel();


        function setDefaults() {
            if (!angular.isDefined(attr.mdDelay)) scope.delay = TOOLTIP_SHOW_DELAY;
        }

        function updateContentOrigin() {
            var origin = 'center top';
            switch (scope.direction) {
                case 'left'  :
                    origin = 'right center';
                    break;
                case 'right' :
                    origin = 'left center';
                    break;
                case 'top'   :
                    origin = 'center bottom';
                    break;
                case 'bottom':
                    origin = 'center top';
                    break;
            }
            content.css('transform-origin', origin);
        }

        function configureWatchers() {
            scope.$on('$destroy', function () {
                scope.visible = false;
                element.remove();
                element = null;
                //angular.element($window).off('resize', debouncedOnResize);
            });

            scope.$on('speed-dial-opened', function () {
                setTimeout(updatePosition, 500);
            });

            scope.$watch('visible', function (isVisible) {
                if (isVisible) showTooltip();
                else hideTooltip();
            });
        }

        function addAriaLabel() {
            if (!parent.attr('aria-label') && !parent.text().trim()) {
                parent.attr('aria-label', element.text().trim());
            }
        }

        function manipulateElement() {
            element.detach();
            element.attr('role', 'tooltip');
        }

        function setVisible(value) {
            setVisible.value = !!value;
            if (!setVisible.queued) {
                if (value) {
                    setVisible.queued = true;
                    $timeout(function () {
                        scope.visible = setVisible.value;
                        setVisible.queued = false;
                    }, scope.delay);
                } else {
                    $mdUtil.nextTick(function () {
                        scope.visible = false;
                    });
                }
            }
        }

        function showTooltip() {
            setTimeout(function () {
                // Insert the element before positioning it, so we can get the position
                // and check if we should display it
                if (!element) return;
                tooltipParent.append(element);

                // Check if we should display it or not.
                // This handles hide-* and show-* along with any user defined css
                if ($mdUtil.hasComputedStyle(element, 'display', 'none')) {
                    scope.visible = false;
                    element.detach();
                    return;
                }

                updatePosition();

                angular.forEach([element, content], function (element) {
                    $animate.addClass(element, 'md-show');
                });
            }, scope.delay);
        }

        function hideTooltip() {
            setTimeout(function () {
                if (!scope.visible && element) element.detach();
            }, 16);
        }

        function updatePosition() {
            if (!element) return;

            if (!scope.visible) {
                element.detach();
                return;
            }

            updateContentOrigin();
            positionTooltip();
        }

        function positionTooltip() {
            var tipRect = $mdUtil.offsetRect(element, tooltipParent);
            var parentRect = $mdUtil.offsetRect(parent, tooltipParent);
            if (parentRect.width == 0) { // quick fix
                parentRect.width = 40;
                parentRect.left -= parentRect.width / 2;
            }
            var newPosition = getPosition(scope.direction);
            var offsetParent = element.prop('offsetParent');

            newPosition = fitInParent(newPosition);

            element.css({
                left: newPosition.left + 'px',
                top: newPosition.top + 'px'
            });

            function fitInParent(pos) {
                var newPosition = {left: pos.left, top: pos.top};
                newPosition.left = Math.min(newPosition.left, tooltipParent.prop('scrollWidth') - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE);
                newPosition.left = Math.max(newPosition.left, TOOLTIP_WINDOW_EDGE_SPACE);
                newPosition.top = Math.min(newPosition.top, tooltipParent.prop('scrollHeight') - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE);
                newPosition.top = Math.max(newPosition.top, TOOLTIP_WINDOW_EDGE_SPACE);
                return newPosition;
            }

            function getPosition(dir) {
                return dir === 'left' ? {
                    left: parentRect.left - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE,
                    top: parentRect.top + parentRect.height / 2 - tipRect.height / 2
                }
                    : dir === 'right' ? {
                    left: parentRect.left + parentRect.width + TOOLTIP_WINDOW_EDGE_SPACE,
                    top: parentRect.top + parentRect.height / 2 - tipRect.height / 2
                } : dir === 'top' ? {
                    left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
                    top: parentRect.top - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE
                } : {
                    left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
                    top: parentRect.top + parentRect.height + TOOLTIP_WINDOW_EDGE_SPACE
                };
            }
        }

    }

}
MdTooltipDirective.$inject = ["$timeout", "$$rAF", "$mdUtil", "$mdTheming", "$animate"];
